import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  CreateDistributionGroupPayload,
  DistributionGroup,
  DistributionGroupDO,
} from '../../../../interfaces/src/lib/distribution-group.interface';

@Injectable({
  providedIn: 'root',
})
export class DistributionGroupService {
  private apiUrl = `${environment.apiUrl}/api/distribution-groups`;

  constructor(private http: HttpClient) {}

  // Create a new distribution group
  createDistributionGroup(groupData: CreateDistributionGroupPayload): Observable<DistributionGroup> {
    return this.http
      .post<{ success: boolean; data: DistributionGroup }>(`${this.apiUrl}`, groupData)
      .pipe(map((res) => res.data), catchError(this.handleError));
  }

  // Get all distribution groups by tenant ID
  getDistributionGroupsByTenant(tenantId: string): Observable<DistributionGroupDO> {
    return this.http
      .get<DistributionGroupDO>(`${this.apiUrl}/tenant/${tenantId}` )
      .pipe(catchError(this.handleError));
  }

  // Update an existing distribution group
  updateDistributionGroup(groupId: string, groupData: Partial<DistributionGroup>): Observable<DistributionGroup> {
    return this.http
      .put<{ success: boolean; data: DistributionGroup }>(`${this.apiUrl}/${groupId}`, groupData)
      .pipe(map((res) => res.data), catchError(this.handleError));
  }

  // Add a user to a distribution group
  addUserToGroup(groupId: string, userId: string): Observable<DistributionGroup> {
    const payload = { groupId, userId };
    return this.http
      .post<DistributionGroup>(`${this.apiUrl}/add-user`, payload)
      .pipe(catchError(this.handleError));
  }

  // Remove a user from a distribution group
  removeUserFromGroup(groupId: string, userId: string): Observable<DistributionGroup> {
    const payload = { groupId, userId };
    return this.http
      .post<DistributionGroup>(`${this.apiUrl}/remove-user`, payload )
      .pipe(catchError(this.handleError));
  }

  // Delete a distribution group
  deleteDistributionGroup(groupId: string): Observable<any> {
    return this.http
      .delete(`${this.apiUrl}/${groupId}`, )
      .pipe(catchError(this.handleError));
  }

  // Handle HTTP errors
  private handleError(error: HttpErrorResponse) {
    // Customize the error handling logic as needed
    let errorMessage = 'An unknown error occurred!';
    if (error.error instanceof ErrorEvent) {
      // Client-side or network error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Backend error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => new Error(errorMessage));
  }
}

